<template>
    <div>
        <div class="page-title">快速連結 Quick Link</div>
        <el-card class="box-card">
             <el-table
                :data="quickLinks"
                style="width: 100%;">
                <el-table-column
                    prop="title"
                    label="Related Link 相關連結"
                    >
                </el-table-column>
                <el-table-column
                    prop="url"
                    label="Action 動作">
                    <template slot-scope="{row}">
                        <el-link type="primary" :href="row.url">Link 連接</el-link>
                    </template>
                </el-table-column>
             </el-table>
        </el-card>

        <div class="copyright-card">
            <copyrightCard></copyrightCard>
        </div>
    </div>
</template>

<script>
    import {getQuickLinks} from '@/api/parent/notification'
    import copyrightCard from '@/components/copyrightCard'
    export default {
        components: { copyrightCard },
        data() {
            return {
                quickLinks: []
            }
        },
        created(){
            this.getQuickLinks()
        },
        methods:{
            getQuickLinks(){
                getQuickLinks().then((v)=>{
                    this.quickLinks = v.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.home-title{
    color: #337AB7;
    font-weight: bold;
    font-size: 25px;
    margin-bottom: 30px;
}
.box-card{
    margin-bottom: 30px;
}
.copyright-card{
    background-color: #fff;
}
</style>